import React, { useState } from "react";
import Footer from "../../Footer";
import NavBar from "../../NavBar";
import AllCards from "./AllCards";
import ExplorerSanValentin from "./ExplorerSanValentin";
import { TyC } from "./TyC";
import NavBarHome from "../../NavBarHome";
import Countdown from "./CountDown";

const PromoSanValentin = () => {
    const [vistaAdministrador, setVistaAdministrador] = useState(false);
    const [refreshHouses, setRefreshHouses] = useState(false);

    return (
        <div>
            <div className="mx-auto">
                <NavBarHome explorer={false} />

                <ExplorerSanValentin
                    vistaAdministrador={vistaAdministrador}
                    setVistaAdministrador={setVistaAdministrador}
                    setRefreshHouses={setRefreshHouses}
                />
                <Countdown />
                <AllCards
                    vistaAdministrador={vistaAdministrador}
                    refreshHouses={refreshHouses}
                    setRefreshHouses={setRefreshHouses}
                />
                {/* <TyC /> */}
            </div>
            <Footer messageWhatsapp="semana_santa" />
        </div>
    );
};

export default PromoSanValentin;
